export var ConversationErrorType;
(function (ConversationErrorType) {
    ConversationErrorType["RefreshConversationFailed"] = "refreshConversationFailed";
    ConversationErrorType["SSEError"] = "sseError";
})(ConversationErrorType || (ConversationErrorType = {}));
export const ConversationScore = {
    NEUTRAL: 0,
    UP: 1,
    DOWN: -1,
};
export const ConversationType = {
    Conversation: "conversation",
    Regeneration: "regeneration",
};
export const FeedbackSystemType = {
    Helpful: "sys_helpful",
    Improve: "sys_improve",
};
//# sourceMappingURL=chat.js.map